import { get, post, put, remove } from "@/api/http";

const api = {
  //获取用户userCode
  findUserCode(corpId, agentId, code) {
    return get(`/findUserCode/${corpId}/${agentId}/${code}`);
  },
  findDefaultUserCode() {
    return get('/wechat/cookie/findDefaultUserCode');
  },
  getDepartmentList() {
    return get(`/api/customer-info/department`);
  },
  createMeetingSign(data){
    return post("/api/meeting-sign/create",data);
  },
  createHospitalSign(data){
    return post("/api/hospital-sign/create",data);
  },
  createNewintSign(data){
    return post("/api/newint-sign/create",data);
  },
  createHospitalSign2(data){
    return post("/api/hospital-sign/createSign",data);
  },
  createEmployeeSign(data){
    return post("/api/meeting-sign/createMeetingSignEmployee",data);
  },
  createCustomerInfo(data){
    return post("/api/customer-info/create",data);
  },
  searchHospitalByCity(city){
    return get('/api/customer-info/hospital?city=' + city);
  },
  suggestToSign(){
    return get('/api/customer-info/toExamPage');
  },
  searchHospitalBykeyword(keyword, city){
    return get('/api/customer-info/hospital/keyword?keyword=' + keyword +"&city=" +city);
  },
  // 根据问卷id获取题目
  findExam(examId) {
    return get(`/api/exam-question/findExam/${examId}`);
  },
  // 根据问卷id获取题目有分型
  findExamAndTyping(examId) {
    return get(`/api/exam-question/findExamAndTyping/${examId}`);
  },
  // 根据用户填写信息获取题目
  findExamId(params) {
    return post('/api/exam-question/findExamId',params);
  },
  // 提交问卷
  saveResult(data) {
    return post('/api/exam-question/saveResult', data);
  },
  // 提交问卷
  saveHospitalResult(data) {
    return post('/api/exam-question/saveHospitalResult', data);
  },
  // 提交问卷
  saveNewintResult(data) {
    return post('/api/exam-question/saveNewintResult', data);
  },
  sendVcode(phone) {
    return get('/api/meeting-sign/sendVCode?phone=' + phone)
  },
  getMeeting(id) {
    return get(`/api/meeting/${id}`)
  },
  getCityMeeting(openid,meetingId) {
    return get('/api/meeting/getCityMeeting?openid=' + openid +"&meetingId=" +meetingId)
  },
  getCityExamIdByDepartment(openid,meetingId) {
    return get('/api/meeting/getCityExamIdByDepartment?openid=' + openid +"&meetingId=" +meetingId);
  },
  getHospital(id) {
    return get(`/api/hospital/${id}`)
  },
  getNewint(id) {
    return get(`/api/newint/${id}`)
  },
  getSignature(data) {
    return post('/api/meeting/getSignature', data)
  },
  getHospitalSignature(data) {
    return post('/api/hospital/getSignature', data)
  },
  getNewintSignature(data) {
    return post('/api/newint/getSignature', data)
  },
  getTypingSignature() {
    return post('/api/typing/getSignature')
  },
  getCustomerInfo(openid) {
    return get('/api/customer-info/getCustomerInfo?openid=' + openid)
  },
  findDictByCategory(category) {
    return get(`/api/dict/category/${category}`);
  }
};

export default api;
